import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const ProvideSafetyLetterSchema = yup.object({
  driverRating: yup.string().required(REQUIRED_MESSAGE),
  vehicleRating: yup.string().required(REQUIRED_MESSAGE),
  jobTitle: yup.string().required(REQUIRED_MESSAGE),
  signatory: yup.string().required(REQUIRED_MESSAGE),
})

export type TProvideSafetyLetterSchema = yup.InferType<typeof ProvideSafetyLetterSchema>

export const getErrorMessage = <
  T extends FieldErrors<TProvideSafetyLetterSchema>,
  K extends keyof T
>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}
